<template>
  <div class="hm-apply">
    <div v-if="isH5" :class="isShowLabelText ? 'h5-apply' : 'h5-apply-taxSaas'">
      <a-form-model :model="form">
        <a-form-model-item label="" v-if="showLabel.includes('name')">
          <div class="input-title">姓名</div>
          <a-input size="large" v-model.trim="form.name" name="name" placeholder="请填写姓名" class="input"/>
        </a-form-model-item>
        <a-form-model-item label="" v-if="showLabel.includes('phoneNo')" class="phone-input">
          <div v-if="isShowLabelText" class="input-title"><span style="color: red;">*</span> 电话</div>
          <a-input size="large" v-model.trim="form.phoneNo" placeholder="请填写电话" class="input">
            <a-select slot="addonBefore" default-value="+86" class="number-select">
              <a-select-option value="+86">
                <span class="font-num">+86</span>
              </a-select-option>
            </a-select>
          </a-input>
        </a-form-model-item>
        <a-form-model-item :class="isShowLabelText ? '': 'phone-input'" label="" v-if="showLabel.includes('verificationCode')">
          <div v-if="isShowLabelText" class="input-title"><span style="color: red;">*</span> 验证码</div>
          <a-input-search size="large" v-model.trim="form.verificationCode" placeholder="请填写验证码" @search="onSendVerifyCode" class="input">
          <a-button slot="enterButton" :loading="codeLoading || countDown !== 0"
          class="enter-button" >
            {{ countDown === 0 ? '获取验证码' : `重新获取(${countDown})` }}
          </a-button>
        </a-input-search>
        </a-form-model-item>
        <a-form-model-item label="" v-if="showLabel.includes('enterpriseName')">
          <div v-if="isShowLabelText" class="input-title"><span style="color: red;">*</span> 企业名称</div>
          <a-input size="large" v-model.trim="form.enterpriseName" name="enterpriseName" placeholder="请填写企业名称" class="input"/>
        </a-form-model-item>
        <a-form-model-item label="" v-if="showLabel.includes('message')">
          <div v-if="isShowLabelText" class="input-title">留言</div>
          <a-input size="large" v-model.trim="form.message" name="message" placeholder="请填写留言" type="textarea"
            class="textarea"
          />
        </a-form-model-item>
        <a-form-model-item class="hm-apply-agreement" v-if="showAgreement">
          <a-checkbox v-model="agreement">
            <span class="isRead-label" >我已阅读并同意</span>
            <a-button type="link" @click.stop.prevent="toPrivacy"><span class="isRead-label">《华盟隐私政策》</span></a-button>
          </a-checkbox>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="hm-apply-btn" size="large" type="blue" block @click="submit">申请试用</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div v-else>
      <a-form-model :model="form">
        <a-form-model-item label="" v-if="showLabel.includes('phoneNo')">
          <a-input size="large" v-model.trim="form.phoneNo" placeholder="请填写手机号">
            <a-select slot="addonBefore" default-value="+86" style="width: 80px">
              <a-select-option value="+86">+86</a-select-option>
            </a-select>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="" v-if="showLabel.includes('verificationCode')">
          <a-input-search size="large" v-model.trim="form.verificationCode" placeholder="请填写验证码" @search="onSendVerifyCode">
          <a-button slot="enterButton" :loading="codeLoading || countDown !== 0">
            {{ countDown === 0 ? '获取验证码' : `重新获取(${countDown})` }}
          </a-button>
        </a-input-search>
        </a-form-model-item>
        <a-form-model-item label="" v-if="showLabel.includes('enterpriseName')">
          <a-input size="large" v-model.trim="form.enterpriseName" name="enterpriseName" placeholder="请填写企业名称" />
        </a-form-model-item>
        <a-form-model-item label="" v-if="showLabel.includes('message')">
          <a-input size="small" v-model.trim="form.message" name="message" placeholder="请填写留言" type="textarea"
          />
        </a-form-model-item>
        <a-form-model-item class="hm-apply-agreement" v-if="showAgreement">
          <a-checkbox v-model="agreement">
            我已阅读并同意
            <a href="#" class="link" @click.stop.prevent="toPrivacy">《华盟隐私政策》</a>
          </a-checkbox>
        </a-form-model-item>
        <a-form-model-item class="hm-apply-action">
          <a-button class="hm-apply-btn" size="large" type="blue" block @click="submit">立即提交</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { isPoneAvailable } from '@/utils/tools'
import { GetSendVerificationCode, PostProbationQuestions } from '@/api/api'
import { mapGetters } from 'vuex'

export default {
  name: 'hmApply',
  props: {
    showAgreement: { // 是否显示隐私政策
      type: Boolean,
      default: true
    },
    isShowLabelText: { // 是否显示文本
      type: Boolean,
      default: false
    },
    showLabel: { // 显示的form字段
      type: Array,
      default: () => ['phoneNo', 'verificationCode', 'enterpriseName']
    },
    productType: {
      type: String,
      default: ''
    },
    onboard: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      form: {
        phoneNo: '', // 手机号
        verificationCode: '', // 验证码
        enterpriseName: '', // 企业名称
        name: '', // 客户名
        message: '', // 留言
        dataSource: 'OfficeWeb' // 数据来源
      },
      agreement: false,
      codeLoading: false,
      countDownTimer: null,
      countDown: 0,
      productTypeList: {
        declaration: 'OneClickDeclaration',
        Taxcellent: 'TP',
        lawLibrary: 'regulatory',
        chataxera: 'ChaTaxera',
        airTax: 'AirTax',
        exportTaxRebate: '出口退税',
      }
    }
  },
  computed: {
    ...mapGetters(['isH5'])
  },
  methods: {
    async onSendVerifyCode () {
      console.log('%c发送验证码', 'background-color: green;color: #fff;', isPoneAvailable(this.form.phoneNo))
      if (this.codeLoading) return
      if (this.form.phoneNo === '' || !isPoneAvailable(this.form.phoneNo)) {
        this.$message.warning('请填写正确格式的手机号码')
        return
      }
      await this.genVerifyCode()
      this.countDownStart()
    },
    genVerifyCode () {
      return new Promise((resolve, reject) => {
        this.codeLoading = true
        GetSendVerificationCode({ phoneNo: this.form.phoneNo }).then(res => {
          console.log('%c获取验证码', 'background-color: green;color: #fff;', res)
          if (res && res.code === '200') {
            this.$message.success('发送成功')
            this.codeLoading = false
            resolve()
          }
        }, err => {
          reject(err)
          this.codeLoading = false
        })
      })
    },
    async submit () {
      const ifValid = this.verifyForm()
      console.log('%c提交', 'background-color: green;color: #fff;', this.form, ifValid)
      if (!ifValid) return
      await this.onApply()
      this.$emit('on-success')
    },
    onApply () {
      return new Promise((resolve, reject) => {
        PostProbationQuestions({
          ...this.form,
          productType: this.productTypeList[this.productType],
          channelSource: this.onboard,
        }).then(res => {
          console.log('%c申请试用', 'background-color: green;color: #fff;', res)
          if (res.code === '200') {
            this.$message.success('提交成功, 稍后会有客服与你联系')
            resolve()
          } else {
            this.$message.error(res.msg)
            reject(new Error(res.msg))
          }
        })
      })
    },
    verifyForm () {
      let flag = true
      for (let key of this.showLabel) {
        console.log(key)
        if (key === 'phoneNo') {
          if (this.form.phoneNo === '' || !isPoneAvailable(this.form.phoneNo)) {
            flag = false
            this.$message.warning('请填写正确格式的手机号码')
            break
          }
        } else if (key === 'verificationCode') {
          if (this.form.verificationCode === '') {
            flag = false
            this.$message.warning('请填验证码')
            break
          }
        } else if (key === 'enterpriseName') {
          if (this.form.enterpriseName === '') {
            flag = false
            this.$message.warning('请填写企业名称')
            break
          }
        }
      }

      if (this.showAgreement && this.agreement === false) {
        flag = false
        this.$message.warning('请阅读并同意下方的《隐私政策》，并勾选确认。')
      }
      return flag
    },
    toPrivacy () {
      // console.log('%c隐私协议', 'background-color: green;color: #fff;')
      this.$router.push({
        path: '/privacy'
      })
    },
    // 倒计时
    countDownStart () {
      this.countDown = 60
      this.countDownTimer = setInterval(() => {
        this.countDown > 0 ? this.countDown-- : this.stopCountDown()
      }, 1000)
    },
    stopCountDown () {
      this.countDown = 0
      if (!this.countDownTimer) return
      clearInterval(this.countDownTimer)
      this.countDownTimer = null
    }
  }
}
</script>

<style lang="less" scoped>
  .hm-apply {
    user-select: none;
    .ant-form-item {
      margin-bottom: 16PX
    }
    /deep/.ant-input-lg {
      font-size: 13PX;
    }
    .hm-apply-agreement.ant-form-item,
    .hm-apply-action.ant-form-item {
      margin-bottom: 16px;
      height: 30PX;
      line-height: 30PX;
    }
    .hm-apply-agreement.ant-form-item {
      margin-top: 18PX;
      text-align: left;
    }
    .hm-apply-agreement {
      /deep/ .ant-checkbox,
      /deep/ .ant-checkbox + span {
        color: #848D9E;
      }
    }
    .ant-btn.ant-btn-link,
    .link {
      color: #3E77FF;
      &:hover {
        opacity: 0.6;
      }
    }
    .ant-btn.ant-input-search-button {
      color: #3E77FF;
      font-size: 14PX;
    }
    .hm-apply-btn {
      background: #3E77FF;
    }
    .ant-input-group-addon {
      background-color: #fff;
    }
    .h5-apply {
      width: 33.5rem;
      // height: 40rem;
      background-color: #fff;
      box-shadow: 0px 8px 16px 0px rgba(206,214,230,0.3);
      border-radius: .8rem;
      margin: 0 auto;
      margin-top: 2.4rem;
      padding: 34px 32px;
      .input-title {
        font-size: 1.5rem;
        color: #292F3A;
      }
      /deep/input {
        font-size: 1.5rem;
        height: 4.2rem;
        background: #FFFFFF;
      }
      .hm-apply-btn {
        height: 3.6rem;
        margin-top: 1.6rem;
      }
      .hm-apply-agreement.ant-form-item {
        margin-bottom: 0px;
        /deep/.ant-checkbox-inner {
          width: 1.6rem;
          height: 1.6rem;
        }
        /deep/.ant-checkbox-wrapper {
          display: flex;
          align-items: center;
        }
      }
    }
    .h5-apply-taxSaas {
      width: 33.5rem;
      margin: 0 auto;
      padding: 0 1.6rem;
      /deep/input {
        font-size: 1.5rem;
        height: 4.2rem;
      }
      /deep/.ant-input::-webkit-input-placeholder {
        font-size: 1.5rem;
        height: 4.2rem;
        line-height: 4.2rem;
      }
      /deep/.ant-select-arrow {
        font-size: 0.8rem;
        right: -0.6rem;
      }
      .hm-apply-btn {
        height: 3.6rem;
        font-size: 30px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 48px;
        font-weight: 500;
        background: #3E77FF;
        border-radius: 8px;
      }
      .hm-apply-agreement.ant-form-item {
        margin-bottom: 0px;
        /deep/.ant-checkbox-wrapper {
        display: flex;
        align-items: center;
        }
        /deep/.ant-btn {
        padding: 0;
        }
      }
      .phone-input {
        // margin-bottom: 32px !important;
        margin-bottom: 32px;
      }
      .input-title{
        font-size: 30px;
        margin-top: 12px;
      }
      .number-select{
        width: 174px;
        height: 84px;
        display: flex;
        align-items: center;
        justify-content: center;
        .font-num{
          font-size: 30px;
        }
      }
      .h5_taxSaas {
        margin-right: 20px;
      }
      .enter-button{
        height: 84px;
        font-size: 30px;
      }
      .textarea{
        min-height: 130px;
        max-height: 130px;
        margin-bottom: 24px;
        &.ant-input {
          font-size: 1.5rem;
        }
      }
      .isRead-label{
        font-size: 30px;
      }
      /deep/ .ant-input-lg, .ant-btn-lg{
        font-size: 28px;
        height: 84px;
        // border-radius: 8px;
      }
      /deep/ .ant-form-item-control{
        line-height: 84px;
      }
      /deep/ .ant-checkbox-inner{
        width: 28px;
        height: 28px;
      }
      .hm-apply-agreement{
        margin-bottom: 23px;
      }
      .hm-apply-btn{
        height: 84px;
        font-weight: bolder;
      }
    }
  }
@media screen and (max-width: 1200px) {
  .hm-apply {
    /deep/.ant-form-item {
      margin-bottom: 8px!important;
    }
    .h5-apply {
      // padding: 34px 32px 48px;
      .phone-input{
        // margin-bottom: 32px!important;
        margin-bottom: 32px;
      }
      .input-title{
        font-size: 30px;
      }
      .number-select{
        width: 174px;
        height: 84px;
        display: flex;
        align-items: center;
        justify-content: center;
        .font-num{
          font-size: 30px;
          margin-right: 20px;
        }
      }
      .enter-button{
        height: 84px;
        font-size: 30px;
      }
      .textarea{
        font-size: 28px;
        height: 100px;
      }
      .isRead-label{
        font-size: 30px;
      }
      /deep/ .ant-input-lg, .ant-btn-lg{
        font-size: 28px;
        height: 84px;
      }
      /deep/ .ant-form-item-control{
        line-height: 84px;
      }
      /deep/ .ant-checkbox-inner{
        width: 28px;
        height: 28px;
      }
      .hm-apply-agreement{
        margin-bottom: 23px;
      }
      .hm-apply-btn{
        height: 84px;
        font-weight: bolder;
      }
    }
  }
}

</style>
<style lang="less">

.hm-apply-agreement {
  span {
    font-size: 12PX;
  }
}
.hm-apply-agreement.ant-form-item {
    margin-bottom: 16px;
    height: 30PX;
    line-height: 30PX;
    text-align: left;
  }
// .ant-form-item {
//   margin-bottom: 16PX;
// }
</style>



// WEBPACK FOOTER //
// src/components/hm-apply/apply-onboard.vue